import { useMemo } from "react";
import { useDataAccumulatorForSingleOrder } from "../../../context/dataAccumulatorForSingleOrder";

/**
 * Checks whether any review documents exist for the current order
 * by reading from the centralized data-accumulator context (Postgres-backed).
 *
 * @returns Object with `hasReviewDocuments` boolean
 */
export const useReviewDocuments = () => {
  const { reviewsData } = useDataAccumulatorForSingleOrder();

  const hasReviewDocuments = useMemo(() => {
    if (reviewsData && reviewsData.reviews && reviewsData.reviews.length > 0) {
      return true;
    }
    return false;
  }, [reviewsData]);

  return {
    hasReviewDocuments,
  };
};
